import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { MdClose, MdGasMeter, MdLocalLaundryService, MdOutlineWifi, MdSecurity } from "react-icons/md";
import { MdOutlineElectricBolt } from "react-icons/md";
import AdvanceRent from "./AdvanceRent";
import OthersModal from "./OthersModal";
import { CiCalendarDate, CiMoneyBill } from "react-icons/ci";
import { MdFoodBank, MdOutlineDevicesOther } from "react-icons/md";
import { GiArchiveRegister, GiAutoRepair } from "react-icons/gi";
import { FaBroom, FaHouseDamage, FaKey } from "react-icons/fa";
import SecurityDue from "./SecurityDue";
import DuesModal from "./DuesModal";


const AddDuesModal = ({
  setIsAddDuesModal,
  addDuesMutate,
  addDuesLoading,
  tenantId,
  rentStartDate,
  initiateEvictionFlow,
  isShowFinalDuesModal,
  setISShowFinalDuesModal,
  advanceRentSlots
}) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const selectOptions = [
    { value: "1", label: "Advance Rent" },
    { value: "2", label: "Security" },
    { value: "3", label: "Maintenance" },
    { value: "4", label: "Electricity" },
    { value: "5", label: "Registration Charges" },
    { value: "9", label: "Food" },
    { value: "10", label: "Fine" },
    { value: "12", label: "Wifi Charges" },
    { value: "13", label: "Gas Charges" },
    { value: "14", label: "Maid Charges" },
    { value: "15", label: "Damage Charges" },
    { value: "16", label: "Key Loss Charges" },
    { value: "17", label: "Laundry Bill" },
    { value: "19", label: "MoveOut Charges" },
    { value: "20", label: "Guest Charges" },
    { value: "7", label: "Other" },
  ];

  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setHeight(window.innerHeight); // updates when Safari UI changes
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const selectedOptionLabel =
    selectOptions.find(opt => opt.value === selectedOption)?.label || '';
  const renderContent = () => {
    switch (selectedOption) {
      case "1":
        return (
          <AdvanceRent
            setIsAddDuesModal={setIsAddDuesModal}
            setSelectedOption={setSelectedOption}
            addDuesMutate={addDuesMutate}
            addDuesLoading={addDuesLoading}
            tenantId={tenantId}
            rentStartDate={rentStartDate}
            selectedOption={selectedOption}
            advanceRentSlots={advanceRentSlots}
          />
        );
      case "7":
        return (
          <OthersModal
            setIsAddDuesModal={setIsAddDuesModal}
            setSelectedOption={setSelectedOption}
            addDuesMutate={addDuesMutate}
            addDuesLoading={addDuesLoading}
            tenantId={tenantId}
            selectedOption={selectedOption}
            isShowFinalDuesModal={isShowFinalDuesModal}
          />
        );
      case "2":
      case "15":
      case "16":
        return (
          <SecurityDue
            setIsAddDuesModal={setIsAddDuesModal}
            setSelectedOption={setSelectedOption}
            addDuesMutate={addDuesMutate}
            addDuesLoading={addDuesLoading}
            tenantId={tenantId}
            selectedOption={selectedOption}
            title={selectedOptionLabel}
          />
        );
      case "3":
      case "4":
      case "5":
      case "9":
      case "10":
      case "12":
      case "13":
      case "14":
      case "17":
      case "19":
      case "20":
        return (
          <DuesModal
            setIsAddDuesModal={setIsAddDuesModal}
            setSelectedOption={setSelectedOption}
            addDuesMutate={addDuesMutate}
            addDuesLoading={addDuesLoading}
            tenantId={tenantId}
            selectedOption={selectedOption}
            isShowFinalDuesModal={isShowFinalDuesModal}
            title={selectedOptionLabel}
          />
        );

      default:
        return (
          <Form>
            <Wrapper>
              <DuesGroup>
                {selectOptions
                  .filter((option) =>
                    initiateEvictionFlow ? option.value !== "1" && option.value !== "2" : true
                  )
                  .filter((option) =>
                    isShowFinalDuesModal ? option.value !== "1" && option.value !== "2" : true
                  )
                  .map((option) => (
                    <DuesOption
                      key={option.value}
                      onClick={() => {
                        setSelectedOption(option.value);
                      }}
                    >
                      <RadioContainer>
                        <RadioCircle isSelected={selectedOption === option.value} />
                        <span className="text-sm">{option.label}</span>
                      </RadioContainer>
                    </DuesOption>
                  ))}

              </DuesGroup>
            </Wrapper>
          </Form>
        );
    }
  };

  const renderHeader = () => {
    switch (selectedOption) {
      case "1":
        return (
          <ProfileSection>
            <UserImage>
              <CiCalendarDate size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Advance Rent</span>
            </UserInfo>
          </ProfileSection>
        );
      case "4":
        return (
          <ProfileSection>
            <UserImage>
              <MdOutlineElectricBolt size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Electricity</span>
            </UserInfo>
          </ProfileSection>
        );
      case "3":
        return (
          <ProfileSection>
            <UserImage>
              <GiAutoRepair size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Maintenance</span>
            </UserInfo>
          </ProfileSection>
        );
      case "9":
        return (
          <ProfileSection>
            <UserImage>
              <MdFoodBank size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Food </span>
            </UserInfo>
          </ProfileSection>
        );
      case "5":
        return (
          <ProfileSection>
            <UserImage>
              <GiArchiveRegister size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Registration Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      case "7":
        return (
          <ProfileSection>
            <UserImage>
              <MdOutlineDevicesOther size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Others </span>
            </UserInfo>
          </ProfileSection>
        );
      case "10":
        return (
          <ProfileSection>
            <UserImage>
              <CiMoneyBill size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Fine </span>
            </UserInfo>
          </ProfileSection>
        );
      case "12":
        return (
          <ProfileSection>
            <UserImage>
              <MdOutlineWifi size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Wifi Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      case "13":
        return (
          <ProfileSection>
            <UserImage>
              <MdGasMeter size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Gas Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      case "14":
        return (
          <ProfileSection>
            <UserImage>
              <FaBroom size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Maid Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      case "17":
        return (
          <ProfileSection>
            <UserImage>
              <MdLocalLaundryService size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Laundry Bill </span>
            </UserInfo>
          </ProfileSection>
        );
      case "2":
        return (
          <ProfileSection>
            <UserImage>
              <MdSecurity size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Security</span>
            </UserInfo>
          </ProfileSection>
        );
      case "15":
        return (
          <ProfileSection>
            <UserImage>
              <FaHouseDamage size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Damage Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      case "16":
        return (
          <ProfileSection>
            <UserImage>
              <FaKey size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Key Loss Charges</span>
            </UserInfo>
          </ProfileSection>
        );
      case "19":
        return (
          <ProfileSection>
            <UserImage>
              <CiMoneyBill size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">MoveOut Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      case "20":
        return (
          <ProfileSection>
            <UserImage>
              <CiMoneyBill size={18} color="#26A69A" />
            </UserImage>
            <UserInfo>
              <span className="font-medium">Guest Charges </span>
            </UserInfo>
          </ProfileSection>
        );
      default:
    }
  };

  return (
    <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
      <Header>
        <Title>{selectedOption ? "Add Dues" : "Select Dues Type"}</Title>
        <CloseButton onClick={() => setIsAddDuesModal(false)}>
          <MdClose size={24} />
        </CloseButton>
      </Header>
      {renderHeader()}
      <Content>{renderContent()}</Content>
    </Container>
  );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-4 h-full flex flex-col justify-between pb-4 relative`;
const Form = tw.form`flex flex-col h-full justify-between`;
const Wrapper = tw.div`grid gap-6 my-6`;
const DuesGroup = tw.div`flex flex-col gap-3 `;
const DuesOption = tw.div`
    flex flex-col gap-2 p-4 border rounded-lg cursor-pointer
    transition-all duration-200 hover:bg-gray-100
`;
const RadioContainer = tw.div`flex items-center gap-3 `;
const RadioCircle = ({ isSelected }) => (
  <div
    className={`w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center ${isSelected ? "border-blue-500" : "border-gray-500"
      }`}
  >
    {isSelected && <div className="w-2 h-2 bg-blue-500 rounded-full" />}
  </div>
);
const UserImage = tw.div`flex w-8 h-8 rounded-full  bg-blue-200 justify-center items-center `;
const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 p-4`;
const UserInfo = tw.div`flex flex-col`;

export default AddDuesModal;
